export const areaListFilterState = ({ organizationId }) => ({
  organizationId,
  page: 1,
  pageSize: 10,
  level: null,
});
